// extracted by mini-css-extract-plugin
module.exports = {"LeaveRequestForm":"LeaveRequestForm_LeaveRequestForm__267Mf","LeaveRequestFormModal":"LeaveRequestForm_LeaveRequestFormModal__1q-np","Casting":"LeaveRequestForm_Casting__2fyLB"};